import React, { useEffect, useState } from "react";
import { useDrag } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import { Targets } from "../../../common/dndHelper";
import { IDropResult, IPlannerMinute, ITripPlanner, ServicedBy, TimelineCommandType } from "../types/plannerTypes";
import DraggingTransfer from "./DraggingTransfer";
import { getShortFullName } from "./plannerHelpers";
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";
import clsx from "clsx";
import { useDispatch } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { setDraggingTripId } from "../../../store/modules/plannerDraggingTripSlice";
import { showTripDetailsModal } from "../../../store/modules/plannerSliceModals";
import { getplannerModalStoreState } from "./plannerHelpers";
import { IVirtualTrip } from "../../../common/plannerTypes";
import { MODAL_TYPE } from "./PlannerTripDetails";
import { getLastVersionVisualState, getLastVersionGlobalState } from "./virtualTripHelpers";
import { useSelector } from "react-redux";
import { checkAcuity, checkuserpermission, checkuserpermissionReschedule } from "../conflictNotices/conflictNoticeHelper";
import { ConflictDialogData, ConflictType, IntervalNumbers } from "../types/conflictNoticeTypes";
import { getData, getRoles, persistName, setData } from "../helpers/transferScheduleHelpers";
import { consts } from "../../../common/consts";
import { ReactComponent as UserIconLogo } from '../../../assets/svgs/user.svg'
import PlannerWidget from "./PlannerWidget";
interface PlannerTripProps {
  plannerMinute: IPlannerMinute;
  showAdHocRequestModal: any;
  isPassed: boolean;
  blockLabel: string | null;
  noOfStretchers: number | null;
  noOfPatientSeats: number | null;
  tripplaner: ITripPlanner;
  setConflictDialogData: any;
  selectedLocationId: string | null;
}

const useStyles = makeStyles({
  timeBlock: {
    width: "calc(100% + 2px)",
    "&:hover": {
      cursor: "grab",
    },
  },
  passedBlock: {
    backgroundColor: "rgba(63, 160, 82, 0.54)",
  },
  trip: {
    height: 30,
    background: "#6698cc",
    zIndex: 40,
    marginLeft: "-1px",
  },
  cusTrip: {
    height: 30,
    background: "#a192b5",
    zIndex: 40,
    marginLeft: "-1px",
  },
  conflictTrip: {
    background: "#f15454",
  },
  tripStart: {
    borderBottomLeftRadius: 8,
    borderTopLeftRadius: 8,
    overflow: "hidden",
  },
  tripEnd: {
    borderBottomRightRadius: 8,
    borderTopRightRadius: 8,
    overflow: "hidden",
  },
  hourTripBorder: {
    // borderLeft: "2px solid #6698cc",
    marginLeft: -2,
  },
  isOverlapped: {
    backgroundColor: "#f47f7b",
    width: "100%",
    height: "100%",
  },
  icon: {
    width: 30,
    height: 30,
    background: '#F4B827',
    padding: 10,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  nameLabel: {
    color: '#F4B827',
    fontSize: 12
  }
});

const PlannerTrip: React.FC<PlannerTripProps> = ({
  plannerMinute,
  isPassed,
  showAdHocRequestModal,
  blockLabel,
  noOfStretchers,
  noOfPatientSeats,
  tripplaner,
  setConflictDialogData,
  selectedLocationId,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { plannerDraggingTripStore } = useSelector((state: RootState) => state);
  const canBeDragged = plannerMinute.trip?.transfers[0]?.scheduleObj.isPlannerDraggable || false;
  const locations = plannerMinute.trip?.transfers[0]?.scheduleObj.patientOfLocation || null;
  const [requested, setrequested] = useState(false);
  const [ShowAdHocModal, setShowAdHocModal] = useState(false);
  const { authStore } = useSelector((state: RootState) => state);
  const [role, setRoles] = React.useState<any>(getRoles(authStore));
  const [{ isDragging }, drag, preview] = useDrag(() => ({
    type: "TransferRequest",
    canDrag: canBeDragged,
    item: {
      transferId: plannerMinute.trip?.virtualTripId,
      priority: plannerMinute.trip?.transfers[0]?.scheduleObj.priority,
      pickupBeforeTime: plannerMinute.trip?.transfers[0]?.scheduleObj.pickupBeforeTime,
      pickupAfterTime: plannerMinute.trip?.transfers[0]?.scheduleObj.pickupAfterTime,
      dropoffBeforeTime: plannerMinute.trip?.transfers[0]?.scheduleObj.dropoffBeforeTime,
      dropoffAfterTime: plannerMinute.trip?.transfers[0]?.scheduleObj.dropoffAfterTime,
      multiload: plannerMinute.trip?.transfers && plannerMinute.trip?.transfers?.length > 1,
      transferAcuity: plannerMinute.trip?.transfers[0]?.scheduleObj.classification,
      location: plannerMinute.trip?.transfers[0].scheduleObj.originCustomerLocationId,
    },
    end: (item, monitor) => {

      const dropResult = monitor.getDropResult() as IDropResult;
      dispatch(
        showTripDetailsModal({
          showTripDetails: false,
          tripDetails: null,
          tripDetailsModalType: MODAL_TYPE.TRIP_DETAILS,
          blockLabel: null,
        })
      );
      if (item && dropResult && dropResult.target === Targets.AD_HOC_REQUESTS) {
        dropResult.removeTripFromPlanner({ virtualTripId: plannerMinute.trip?.virtualTripId, tripPlannerId: plannerMinute.trip?.tripPlannerId,type:Targets.AD_HOC_REQUESTS }); // drag from timeline to requested       
        // drag from timeline to ad-hoc
        const lastVersionOfGlobalState = getLastVersionGlobalState().map((r: IVirtualTrip) => r.transfers[0].scheduleObj);
        const lastVersionOfTransfer = lastVersionOfGlobalState.find((t) => t.transferId === item.transferId);
        showAdHocRequestModal({
          transferId: item.transferId,
          mobility: lastVersionOfTransfer?.mobility,
          priority: lastVersionOfTransfer?.priority,
          pickupBeforeTime: lastVersionOfTransfer?.pickupBeforeTime,
          pickupAfterTime: lastVersionOfTransfer?.pickupAfterTime,
          dropoffBeforeTime: lastVersionOfTransfer?.dropoffBeforeTime,
          dropoffAfterTime: lastVersionOfTransfer?.dropoffAfterTime,
        });
        return;
      }
      if (item && dropResult && dropResult.target === Targets.REQUESTED) {
        var role = "";
        if (tripplaner.sharingRole === null) {
          role = consts.Permissions.Primary;
        }
        else {
          role = tripplaner.sharingRole;
        }
        var superuser = (authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.SMASuperUser));
        if (superuser !== true) {
          if (authStore.data?.IsAdmin || authStore.data?.IsSMAUser) {
            const userper = checkuserpermission(tripplaner.sharingRole, role === consts.Permissions.Primary ? Boolean(authStore.data?.role.split(",")?.
              some((p) => p == consts.Permissions.SMARemovetransfers)) : (Boolean(authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.SMARemovetransfersSecondary))));
            if (userper !== null) {
              setConflictDialogData(userper);
              return null;
            }
          }
          else {
            const userper = checkuserpermission(tripplaner.sharingRole, role === consts.Permissions.Primary ? Boolean(authStore.data?.role.split(",")?.
              some((p) => p == consts.Permissions.Removetransfers)) : (Boolean(authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.RemovetransfersSecondary))));
            if (userper !== null) {
              setConflictDialogData(userper);
              return null;
            }
          }
        }
        var SelectedLocation = localStorage.getItem("SelectedLocation");
        if (SelectedLocation === item.location) {
          dropResult.removeTripFromPlanner({ virtualTripId: plannerMinute.trip?.virtualTripId, tripPlannerId: plannerMinute.trip?.tripPlannerId,type:Targets.REQUESTED }); // drag from timeline to requested       
          return;
        }
        else {
          dropResult.removeTripFromPlanner({ virtualTripId: plannerMinute.trip?.virtualTripId, tripPlannerId: plannerMinute.trip?.tripPlannerId,type:Targets.REQUESTED }); // drag from timeline to requested        
          return;
        }
      }
      // mostly insurance that it take last version of the trip
      if (dropResult && dropResult.target === Targets.PLANNER_TIMELINE) {
        var role: string = "";
        if (tripplaner.sharingRole === null) {
          role = consts.Permissions.Primary;
        }
        else {
          role = tripplaner.sharingRole;
        }
        var superuser = (authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.SMASuperUser));
        if (superuser !== true) {
          if (authStore.data?.IsAdmin || authStore.data?.IsSMAUser) {
            const userper = checkuserpermissionReschedule(tripplaner.sharingRole, role === consts.Permissions.Primary ? Boolean(authStore.data?.role.split(",")?.
              some((p) => p == consts.Permissions.SMARescheduletrips)) : (Boolean(authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.SMARescheduletripsSecondary))));
            if (userper !== null) {
              setConflictDialogData(userper);
              return null;
            }
          }
          else {
            const userper = checkuserpermissionReschedule(tripplaner.sharingRole, role === consts.Permissions.Primary ? Boolean(authStore.data?.role.split(",")?.
              some((p) => p == consts.Permissions.Rescheduletrips)) : (Boolean(authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.RescheduletripsSecondary))));
            if (userper !== null) {
              setConflictDialogData(userper);
              return null;
            }
          }
        }

        var updatedDropResultTrip:any={...dropResult?.plannerMinute?.trip};
        if (dropResult?.plannerMinute?.trip && updatedDropResultTrip) {
          updatedDropResultTrip.isTripMinOverrided = false;
          updatedDropResultTrip.overrideTripEstimateInMin = 0;
      }

        const lastVersionOfTrip = getLastVersionVisualState().find((v) => v.virtualTripId === plannerMinute.trip?.virtualTripId);
        if (dropResult?.plannerMinute?.trip && updatedDropResultTrip && plannerMinute.trip?.virtualTripId !== updatedDropResultTrip?.virtualTripId) {
          // convert to multi load transfer
          dropResult.applyTimelineChanges(lastVersionOfTrip, {
            type: TimelineCommandType.addToTrip,
            tripUpdates: updatedDropResultTrip,
          });
          return;
        } else {

          dropResult.applyTimelineChanges(lastVersionOfTrip, {
            type: TimelineCommandType.moveTrip,
            plannerMinute: dropResult.plannerMinute,
          });
          return;
        }
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
      handlerId: monitor.getHandlerId(),
    }),
  }));

  React.useEffect(() => {

    preview(getEmptyImage());
  }, []);

  const UserPermission = (roles: string | null) => {
    var role = null;
    if (tripplaner.sharingRole === null) {
      role = consts.Permissions.Primary;
    }
    else {
      role = roles;
    }
    var superuser = (authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.SMASuperUser));
    if (superuser !== true) {
      if (authStore.data?.IsAdmin  || authStore.data?.IsSMAUser) {
        const userper = checkuserpermissionReschedule(roles, role === consts.Permissions.Primary ? Boolean(authStore.data?.role.split(",")?.
          some((p) => p == consts.Permissions.SMARescheduletrips)) : (Boolean(authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.SMARescheduletripsSecondary))));
        if (userper !== null) {
          setConflictDialogData(userper);
          return null;
        }
      }
      else {
        const userper = checkuserpermissionReschedule(roles, role === consts.Permissions.Primary ? Boolean(authStore.data?.role.split(",")?.
          some((p) => p == consts.Permissions.Rescheduletrips)) : (Boolean(authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.RescheduletripsSecondary))));
        if (userper !== null) {
          setConflictDialogData(userper);
          return null;
        }
      }
    }

  }
  React.useEffect(() => {
    if (plannerMinute.trip) {
      if (isDragging) {
        // hide block
        // UserPermission(tripplaner.sharingRole);
        dispatch(setDraggingTripId(plannerMinute.trip.virtualTripId));
      } else {
        // show block
        setTimeout(() => {
          dispatch(setDraggingTripId(null));
        }, 100);
      }
    }
  }, [isDragging]);

  const onClickAction = () => {
    if (plannerMinute.trip) {
      const showTripDetails = getplannerModalStoreState().showTripDetails;
      dispatch(
        showTripDetailsModal({
          showTripDetails: !showTripDetails,
          tripDetails: showTripDetails ? null : plannerMinute.trip,
          tripDetailsModalType: MODAL_TYPE.TRIP_DETAILS,
          blockLabel: showTripDetails ? null : blockLabel,
          noOfStretchers: noOfStretchers,
          noOfPatientSeats: noOfPatientSeats,
          showLayerUnder: true,
        })
      );
    }
  };

  const transferStatusText = () => {
    switch (plannerMinute.trip?.transfers[0].scheduleObj.status) {
      case 3:
        return "In Progress";
      case 4:
      case 10:
        return "Completed";
      case 6:
        return "Aborted";
      case 7:
        return "in status Picking Up";
      case 8:
        return "in status EnRoute To Destination";
      case 9:
        return "in status Dropping Off";
      case 11:
        return "Cancelled";
      default:
        return null;
    }
  };
  return (
    <>

      {plannerMinute.trip && !plannerMinute.tripStyle.isInsivible && (
        <Tooltip title={canBeDragged || !transferStatusText() ? "" : `This transfer is ${transferStatusText()} and can no longer be modified`}>
          <div
            className={clsx(classes.timeBlock, Number(tripplaner.servicedBy) == ServicedBy.SMA ? classes.trip : classes.cusTrip, {
              [classes.tripStart]: plannerMinute.tripStyle.isTripBlockStart,
              [classes.tripEnd]: plannerMinute.tripStyle.isTripBlockEnd,
              [classes.conflictTrip]:
                plannerMinute.tripStyle.isConflictingTrip &&
                !(plannerMinute.tripStyle.isOverlapped && plannerMinute.tripStyle.isOverlappedEnd && plannerMinute.tripStyle.isTripEnd) &&
                !(plannerMinute.tripStyle.isOverlapped && plannerMinute.tripStyle.isOverlappedStart && plannerMinute.tripStyle.isTripStart),
              [classes.hourTripBorder]: plannerMinute.date.getMinutes() % 60 === 0,

            })}
            ref={drag}
            onClick={onClickAction}
          >
            <div
              className={clsx({
                [classes.isOverlapped]: plannerMinute.tripStyle.isOverlapped,
                [classes.tripStart]: plannerMinute.tripStyle.isOverlapped && plannerMinute.tripStyle.isOverlappedStart,
                [classes.tripEnd]: plannerMinute.tripStyle.isOverlapped && plannerMinute.tripStyle.isOverlappedEnd,
                [classes.passedBlock]: isPassed,
              })}
            ></div>
          </div>
        </Tooltip>
      )}

      {isDragging && (
        <DraggingTransfer
          // what should be here for multiload trip?
          name={getShortFullName(
            plannerMinute.trip?.transfers[0].scheduleObj.firstName ?? "",
            plannerMinute.trip?.transfers[0].scheduleObj.lastName ?? ""
          )}
          adjustForTransferRequest={false}
          Draglocation={locations}
          selectedLocationId={selectedLocationId}
        />
      )}

    </>

  );
};
export default PlannerTrip;
